import { ComponentType, lazy } from "react";

/**
 * Augments React.lazy with a page refresh if the component import fails.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const lazyWithReload = (componentImport: () => Promise<{ default: ComponentType<any> }>) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem("lingo-lazy-refresh") || "false"
    );

    try {
      const component = await componentImport();
      window.localStorage.setItem("lingo-lazy-refresh", "false");
      return component;
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        window.localStorage.setItem("lingo-lazy-refresh", "true");
        window.location.reload();
        throw new Error("Page is reloading for lazy component update.");
      }

      throw error;
    }
  });
